import { Pipe, PipeTransform } from '@angular/core';
import { dateFns } from '@core/date-utils';

@Pipe({
  name: 'dayDiff',
})
export class DayDiffPipe implements PipeTransform {
  transform(startDate: Date | string, endDate: Date | string): string {
    const daysRemaining = dateFns.daysBetweenDates(startDate, endDate);
    return daysRemaining > 1 ? `${daysRemaining} dager` : `${daysRemaining} dag`;
  }
}
